import {
  createContext,
  useContext,
} from 'react';

const MobileMenuContext = createContext({
  open: false,
  toggleOpen: () => {},
});

export const useMobileMenuContext = () =>
  useContext(MobileMenuContext);

const MobileMenuProvider = ({
  value,
  children,
}) => (
  <MobileMenuContext.Provider value={value}>
    {children}
  </MobileMenuContext.Provider>
);

export default MobileMenuProvider;
